import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeftIcon } from 'lucide-react';
import type { JSX } from 'react';

import { GlobalActivityFeed } from '@/features/developers/GlobalActivityFeed.js';
import { ensureDeveloperEnabled } from '@/features/developers/guard.js';

export const Route = createFileRoute('/developer_/activity')({
  component: GlobalActivityPage,
  beforeLoad: () => ensureDeveloperEnabled(),
});

/** `/developer/activity` — one timeline of the runs of every developer in the user's own workspaces. */
function GlobalActivityPage(): JSX.Element {
  return (
    <div className="flex w-full flex-col gap-5 px-4 py-6 sm:px-6 lg:px-8">
      <div className="flex min-w-0 items-center gap-2">
        <Link
          to="/developer"
          className="flex size-8 shrink-0 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground"
          aria-label="Back to Developer"
        >
          <ArrowLeftIcon className="size-4" aria-hidden />
        </Link>
        <h1 className="truncate font-heading text-xl font-bold tracking-tight">
          Developer activity
        </h1>
      </div>
      <GlobalActivityFeed />
    </div>
  );
}
